import React from 'react';
import { useT } from '~app/core/BundleProvider';

const ProgressBar = ({ step }) => {
  const t = useT();
  return (
    <div className="progress-container">
      {step === 1 && (
        <div className="progressbar-container">
          <ul className="progressbar">
            <li aria-current="step" className="active  progressbar-1">
              {t('upload-answer')}
              <span className="visually-hidden">current step</span>
            </li>
            <li>{t('upload-models')}</li>
            <li>{t('view-results')}</li>
          </ul>
        </div>
      )}
      {(step === 2 || step === 3) && (
        <div className="progressbar-container">
          <ul className="progressbar">
            <li className="complete progressbar-1">{t('upload-answer')}</li>
            <li aria-current="step" className="active progressbar-2">
              {t('upload-models')}
              <span className="visually-hidden">current step</span>
            </li>
            <li>{t('view-results')}</li>
          </ul>
        </div>
      )}
      {step === 4 && (
        <div className="progressbar-container">
          <ul className="progressbar">
            <li className="complete-prev progressbar-1">
              {t('upload-answer')}
            </li>
            <li className="complete progressbar-2">{t('upload-models')}</li>
            <li aria-current="step" className="active progressbar-3">
              {t('view-results')}
              <span className="visually-hidden">current step</span>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
